import { fetch } from 'app/utils/data'
import { default as deserialize } from 'app/utils/deserialize'

export default {
  namespaced: true,

  state: {
    item: null
  },

  getters: {
    braintreeClientToken: (state) => state.item
  },

  mutations: {
    resetState: (state) => (state.item = null),

    clientTokenFetched(state, { token }) {
      state.item = token
    }
  },

  actions: {
    async getBraintreeClientToken({ commit }) {
      try {
        const response = await fetch({
          url: `/api/braintree-client`,
          type: 'braintree-client'
        })

        const data = await deserialize(response.data)

        commit('clientTokenFetched', { token: data.token })
        return data.token
      } catch (e) {
        return null
      }
    }
  }
}
